/* ==========================================================================
   Plant Store <> UnfoldCRO — Header behaviour
   Mega menu, mobile drawer, mobile search overlay, predictive search,
   cart-count mirroring.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-ufc-header]');
  if (!root) return;

  var body = document.body;

  /* ---------------------------------------------------------------- utils */

  function on(el, type, fn, opts) {
    if (el) el.addEventListener(type, fn, opts);
  }

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || root).querySelectorAll(selector));
  }

  function lockScroll(locked) {
    body.classList.toggle('ufc-overlay-open', locked);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Ask the Shopify CDN for a right-sized image instead of the full-size one.
  function sized(url, width) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', width);
      return parsed.href;
    } catch (error) {
      return url;
    }
  }

  /* ------------------------------------------------------------ mega menu */

  var megaToggles = all('[data-ufc-mega-toggle]');

  function closeMega(except) {
    megaToggles.forEach(function (toggle) {
      if (toggle === except) return;
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  // The plain dropdown sits under the menu item that opened it, so it needs that
  // item's offset. The panel is a sibling of the nav rather than a child of the
  // item, so the offset cannot come from CSS alone.
  function placeMega(toggle, panel) {
    if (!panel.classList.contains('ufc-mega--plain')) return;
    var align = panel.querySelector('.ufc-mega__align');
    var box = panel.querySelector('.ufc-mega__panel');
    if (!align || !box) return;

    // Measured while visible: a hidden panel has no box to measure.
    box.style.setProperty('--ufc-mega-x', '0px');
    var alignBox = align.getBoundingClientRect();
    var alignStyle = window.getComputedStyle(align);
    var padLeft = parseFloat(alignStyle.paddingLeft) || 0;
    var padRight = parseFloat(alignStyle.paddingRight) || 0;
    var contentLeft = alignBox.left + padLeft;
    var contentWidth = alignBox.width - padLeft - padRight;

    var x = toggle.getBoundingClientRect().left - contentLeft;
    // Never past the right edge of the container, and never left of it.
    var maxX = contentWidth - box.getBoundingClientRect().width;
    if (x > maxX) x = maxX;
    if (x < 0) x = 0;
    box.style.setProperty('--ufc-mega-x', Math.round(x) + 'px');
  }

  var hoverPointer = !!(
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches
  );

  megaToggles.forEach(function (toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    var openTimer = null;
    var closeTimer = null;

    function openPanel() {
      closeMega(toggle);
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      placeMega(toggle, panel);
    }

    function closePanel() {
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }

    function cancelTimers() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
    }

    function scheduleOpen() {
      cancelTimers();
      if (!panel.hidden) return;
      openTimer = window.setTimeout(openPanel, 90);
    }

    function scheduleClose() {
      cancelTimers();
      closeTimer = window.setTimeout(closePanel, 180);
    }

    on(toggle, 'click', function (event) {
      event.preventDefault();
      cancelTimers();
      if (toggle.getAttribute('aria-expanded') === 'true') {
        closePanel();
      } else {
        openPanel();
      }
    });

    // A resize while it is open would leave it under the wrong item.
    on(window, 'resize', function () {
      if (!panel.hidden) placeMega(toggle, panel);
    });

    if (hoverPointer) {
      on(toggle, 'mouseenter', scheduleOpen);
      on(toggle, 'mouseleave', scheduleClose);
      on(panel, 'mouseenter', cancelTimers);
      on(panel, 'mouseleave', scheduleClose);
      return;
    }

    on(panel, 'mouseleave', closePanel);
  });

  // Clicking anywhere outside the header closes an open mega panel.
  on(document, 'click', function (event) {
    if (!megaToggles.length) return;
    if (root.contains(event.target)) return;
    closeMega();
  });

  // Single-open accordion inside each mega panel.
  all('[data-ufc-mega-group]').forEach(function (toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    on(toggle, 'click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      var siblings = all('[data-ufc-mega-group]', toggle.closest('[data-ufc-mega-groups]'));

      siblings.forEach(function (sibling) {
        var siblingPanel = document.getElementById(sibling.getAttribute('aria-controls'));
        sibling.setAttribute('aria-expanded', 'false');
        if (siblingPanel) siblingPanel.hidden = true;
      });

      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;
    });
  });

  /* --------------------------------------------------------- mobile drawer */

  var drawer = document.querySelector('[data-ufc-drawer]');
  var searchOverlay = document.querySelector('[data-ufc-search-overlay]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    lockScroll(open);
    all('[data-ufc-drawer-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      var first = drawer.querySelector('[data-ufc-drawer-close]');
      if (first) first.focus();
    }
  }

  function setSearchOverlay(open) {
    if (!searchOverlay) return;
    searchOverlay.hidden = !open;
    lockScroll(open);
    if (open) {
      var input = searchOverlay.querySelector('input[type=search]');
      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 40);
      }
    }
  }

  all('[data-ufc-drawer-open]').forEach(function (btn) {
    on(btn, 'click', function (event) {
      event.preventDefault();
      setSearchOverlay(false);
      setDrawer(true);
    });
  });

  if (drawer) {
    all('[data-ufc-drawer-close]', drawer).forEach(function (btn) {
      on(btn, 'click', function () {
        setDrawer(false);
      });
    });

    all('[data-ufc-drawer-group]', drawer).forEach(function (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;

      on(toggle, 'click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        all('[data-ufc-drawer-group]', drawer).forEach(function (sibling) {
          var siblingPanel = document.getElementById(sibling.getAttribute('aria-controls'));
          sibling.setAttribute('aria-expanded', 'false');
          if (siblingPanel) siblingPanel.hidden = true;
        });
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });
  }

  /* ------------------------------------------------- mobile search overlay */

  all('[data-ufc-search-open]').forEach(function (btn) {
    on(btn, 'click', function (event) {
      event.preventDefault();
      setDrawer(false);
      setSearchOverlay(true);
    });
  });

  if (searchOverlay) {
    all('[data-ufc-search-close]', searchOverlay).forEach(function (btn) {
      on(btn, 'click', function () {
        setSearchOverlay(false);
      });
    });
  }

  /* ------------------------------------------------------ predictive search */

  // Formats against the shop's own money format so search results read the
  // same as every Liquid-rendered price on the site.
  var money = (function () {
    // Any element on the page may publish the shop's money format; the
    // product card does. Falls back to a plain grouped number.
    var holder = document.querySelector('[data-money-format]');
    var format = ((holder && holder.getAttribute('data-money-format')) || '{{amount}}').replace(
      /<[^>]*>/g,
      ''
    );

    function build(amount, decimals, thousands, decimalMark) {
      var parts = amount.toFixed(decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimalMark + parts[1] : whole;
    }

    return function (value) {
      var amount = parseFloat(String(value).replace(/[^0-9.]/g, ''));
      if (isNaN(amount)) return '';

      return format
        .replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
          switch (name) {
            case 'amount_no_decimals':
              return build(amount, 0, ',', '.');
            case 'amount_with_comma_separator':
              return build(amount, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return build(amount, 0, '.', ',');
            case 'amount_with_apostrophe_separator':
              return build(amount, 2, "'", '.');
            default:
              return build(amount, 2, ',', '.');
          }
        })
        .replace(/([.,])00$/, '');
    };
  })();

  function resultMarkup(product, prefix) {
    var image = '';
    if (product.featured_image && product.featured_image.url) {
      image = product.featured_image.url;
    } else if (product.image) {
      image = product.image;
    }

    // suggest.json returns `type`, not `product_type`.
    var meta = product.type || product.product_type || product.vendor || '';
    var price = product.price == null ? '' : money(product.price);
    var out = [];

    out.push('<li><a class=' + q(prefix + 'result') + ' href=' + q(product.url) + ' role=option>');

    if (image) {
      out.push('<img loading=lazy alt="" class=' + q(prefix + 'result-img') + ' src=' + q(sized(image, 200)) + '>');
    } else {
      out.push('<span class=' + q(prefix + 'result-img') + '></span>');
    }

    out.push('<span class=' + q(prefix + 'result-body') + '>');
    out.push('<span class=' + q(prefix + 'result-title') + '>' + escapeHtml(product.title) + '</span>');
    if (meta) {
      out.push('<span class=' + q(prefix + 'result-meta') + '>' + escapeHtml(meta) + '</span>');
    }
    out.push('</span>');

    if (price) {
      out.push('<span class=' + q(prefix + 'result-price') + '>' + escapeHtml(price) + '</span>');
    }

    out.push('</a></li>');
    return out.join('');
  }

  // Quote an HTML attribute value.
  function q(value) {
    return String.fromCharCode(34) + escapeHtml(value) + String.fromCharCode(34);
  }

  function buildSearch(scope) {
    var form = scope.querySelector('[data-ufc-search-form]');
    if (!form) return;

    var input = form.querySelector('input[type=search]');
    var panel = scope.querySelector('[data-ufc-search-panel]');
    var idle = scope.querySelector('[data-ufc-search-idle]');
    var resultsList = scope.querySelector('[data-ufc-search-results]');
    var empty = scope.querySelector('[data-ufc-search-empty]');
    var emptyTerm = scope.querySelector('[data-ufc-search-empty-term]');
    var viewAll = scope.querySelector('[data-ufc-search-viewall]');
    var viewAllTerm = scope.querySelector('[data-ufc-search-viewall-term]');
    var clear = scope.querySelector('[data-ufc-search-clear]');
    var isDropdown = !!(panel && panel.hasAttribute('data-ufc-search-dropdown'));
    var prefix = isDropdown ? 'ufc-search__' : 'ufc-msearch__';

    if (!input || !resultsList) return;

    var controller = null;
    var timer = null;
    var searchUrl = form.getAttribute('action') || '/search';

    function openPanel(open) {
      if (!isDropdown) return;
      panel.hidden = !open;
      scope.classList.toggle('is-open', open);
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function renderIdle() {
      if (idle) idle.hidden = false;
      if (empty) empty.hidden = true;
      if (viewAll) viewAll.hidden = true;
      resultsList.innerHTML = '';
      resultsList.hidden = true;
    }

    function renderResults(products, term) {
      if (idle) idle.hidden = true;

      if (!products.length) {
        resultsList.innerHTML = '';
        resultsList.hidden = true;
        if (empty) {
          empty.hidden = false;
          if (emptyTerm) emptyTerm.textContent = term;
        }
      } else {
        if (empty) empty.hidden = true;
        resultsList.hidden = false;
        resultsList.innerHTML = products
          .map(function (product) {
            return resultMarkup(product, prefix);
          })
          .join('');
      }

      if (viewAll) {
        viewAll.hidden = false;
        viewAll.href = searchUrl + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
        if (viewAllTerm) viewAllTerm.textContent = term;
      }
    }

    function fetchResults(term) {
      if (controller) controller.abort();
      controller = typeof AbortController === 'undefined' ? null : new AbortController();

      var url = '/search/suggest.json?q=' + encodeURIComponent(term);
      url += '&resources[type]=product&resources[limit]=5';
      url += '&resources[options][unavailable_products]=last';
      url += '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then(function (data) {
          var results = data && data.resources && data.resources.results;
          renderResults((results && results.products) || [], term);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          renderResults([], term);
        });
    }

    on(input, 'input', function () {
      var term = input.value.trim();
      if (clear) clear.hidden = term.length === 0;
      window.clearTimeout(timer);

      if (term.length < 0) {
        renderIdle();
        return;
      }

      timer = window.setTimeout(function () {
        fetchResults(term);
      }, 220);
    });

    on(input, 'focus', function () {
      openPanel(true);
    });

    on(clear, 'click', function (event) {
      event.preventDefault();
      input.value = '';
      clear.hidden = true;
      renderIdle();
      input.focus();
    });

    // Trending chips prefill the field and run the query.
    all('[data-ufc-search-chip]', scope).forEach(function (chip) {
      on(chip, 'click', function (event) {
        event.preventDefault();
        input.value = chip.textContent.trim();
        if (clear) clear.hidden = false;
        openPanel(true);
        input.focus();
        fetchResults(input.value);
      });
    });

    // Keyboard navigation through results.
    on(input, 'keydown', function (event) {
      var isDown = event.key === 'ArrowDown';
      var isUp = event.key === 'ArrowUp';
      if (!isDown && !isUp && event.key !== 'Enter') return;

      var links = all('a', resultsList);
      if (!links.length) return;

      var current = links.indexOf(resultsList.querySelector('.is-active'));

      if (event.key === 'Enter') {
        if (current > -1) {
          event.preventDefault();
          links[current].click();
        }
        return;
      }

      event.preventDefault();
      var next = isDown ? current + 1 : current - 1;
      if (next < 0) next = links.length - 1;
      if (next >= links.length) next = 0;

      links.forEach(function (link) {
        link.classList.remove('is-active');
      });
      links[next].classList.add('is-active');
      links[next].scrollIntoView({ block: 'nearest' });
    });

    if (isDropdown) {
      on(document, 'click', function (event) {
        if (!scope.contains(event.target)) openPanel(false);
      });
    }

    scope.ufcCloseSearch = function () {
      openPanel(false);
    };
  }

  all('[data-ufc-search-scope]').forEach(buildSearch);

  /* ------------------------------------------------------------- cart sync */

  var cartSource = document.getElementById('cart-icon-bubble');

  function syncCartCount() {
    if (!cartSource) return;
    var source = cartSource.querySelector('[data-ufc-cart-count]');
    var count = source ? source.textContent.trim() : '0';
    var mirrors = Array.prototype.slice.call(document.querySelectorAll('[data-ufc-cart-mirror]'));

    mirrors.forEach(function (target) {
      target.textContent = count;
      target.hidden = !count || count === '0';
    });
  }

  if (cartSource && typeof MutationObserver !== 'undefined') {
    new MutationObserver(syncCartCount).observe(cartSource, { childList: true, subtree: true });
  }
  syncCartCount();

  // Dawn's cart-drawer binds itself to #cart-icon-bubble (the desktop cart
  // button) on its own. The mobile cart icon is a separate element, so wire
  // it up here — falling through to /cart when there is no drawer.
  all('.ufc-icon-btn--cart').forEach(function (link) {
    on(link, 'click', function (event) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open(link);
    });
  });

  /* ------------------------------------------------------------ global esc */

  on(document, 'keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeMega();
    setDrawer(false);
    setSearchOverlay(false);
    all('[data-ufc-search-scope]').forEach(function (scope) {
      if (scope.ufcCloseSearch) scope.ufcCloseSearch();
    });
  });
})();
